import React from "react";
import CenterWrapper from "../CenterWrapper";
import MaterialForm from "./MaterialForm";
import useRole from "../../../utils/useRole";
import { Navigate } from "react-router-dom";

const AddMaterial = () => {
  const { isUser } = useRole();
  if (isUser) {
    return <Navigate to={"/unauthorized"} replace />;
  }
  return (
    <CenterWrapper>
      <h2 className="mt-4 text-2xl font-bold">Add Material</h2>
      <div className="mt-4">
        <MaterialForm isEdit={false} />
      </div>
    </CenterWrapper>
  );
};

export default AddMaterial;
